module.exports = __webpack_public_path__ + "83e39217dcf4ac11bb7e12c5f5937e97.svg";


//////////////////
// WEBPACK FOOTER
// ./Content/background.svg
// module id = ./Content/background.svg
// module chunks = 8